import { PaginationType } from "@lib/types/Api";
import { AxiosResponse } from "axios";
import { FormattedMessage } from "react-intl";
import { StyledFlex, StyledTableInfoAlert } from "./index.styled";
import { FaInfoCircle } from "react-icons/fa";
import { Skeleton } from "antd";

type Props = {
  data: AxiosResponse<PaginationType<any>, any>;
  loading?: boolean;
};

export default function TableInfo({ data, loading }: Props) {
  if (loading) return <Skeleton.Input active block />;

  return (
    <StyledTableInfoAlert
      type={"info"}
      message={
        <StyledFlex style={{ justifyContent: "end" }}>
          <FaInfoCircle
            style={{ color: "#4b7cf3", paddingRight: "5px" }}
            size={18}
          />
          <FormattedMessage
            id="common.displayingOutOfTotal"
            values={{
              page: data?.data?.count || 1,
              total: data?.data?.total || 1,
            }}
          />
        </StyledFlex>
      }
    />
  );
}
